import { render } from "./CallPartner.vue?vue&type=template&id=a97a9830"
import script from "./CallPartner.vue?vue&type=script&lang=js"
export * from "./CallPartner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__